export default "__VITE_ASSET__BacQx$X0__"